import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";
import {
  GET_ALL_PACKAGE_TRANSACTION,
  ADD_PACKAGE_TRANSACTION,
  UPDATE_PACKAGE_TRANSACTION,
  UPDATE_PACKAGE_TRANSACTION_STATUS,
  DELETE_PACKAGE_TRANSACTION,
} from "../types";

// ===============================
// 👉 ADD PACKAGE TRANSACTION
// ===============================
export const addPackageTransaction = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("packageTransaction/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_PACKAGE_TRANSACTION, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);
        Swal.fire({
          title: "Warning!",
          text: res.data.message,
          icon: "warning",
        });
      }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    const errorMessage = getErrorMessage(err.response?.data);
    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

// ===============================
// 👉 GET ALL PACKAGE TRANSACTIONS
// ===============================
export const getPackageTransaction = () => async (dispatch) => {
  try {
    const res = await axios.get("packageTransaction/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_ALL_PACKAGE_TRANSACTION, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

// ===============================
// 👉 UPDATE PACKAGE TRANSACTION
// ===============================
export const updatePackageTransaction = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("packageTransaction/update", formData);
    if (res.data.code === 1) {
      dispatch({
        type: UPDATE_PACKAGE_TRANSACTION,
        payload: res.data.data,
      });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

// ===============================
// 👉 UPDATE PACKAGE TRANSACTION STATUS
// ===============================
export const updatePackageTransactionStatus =
  (formData) => async (dispatch) => {
    try {
      const updatedFormData = {
        id: formData.id,
        ...(formData.status !== undefined && { status: formData.status }),
      };

      const res = await axios.post(
        "packageTransaction/update/status",
        updatedFormData
      );
      if (res.data.code === 1) {
        dispatch({
          type: UPDATE_PACKAGE_TRANSACTION_STATUS,
          payload: res.data.data,
        });
        Swal.fire({
          title: "Success!",
          text: res.data.message,
          icon: "success",
        });
        dispatch(setAlert(res.data.message, "success"));
      } else {
        dispatch(setAlert(res.data.message, "warning"));
        Swal.fire({
          title: "Warning!",
          text: res.data.message,
          icon: "warning",
        });
      }
    } catch (err) {
      dispatch(setAlert(err.message, "danger"));
    }
  };

// ===============================
// 👉 DELETE PACKAGE TRANSACTION
// ===============================
export const deletePackageTransaction = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`packageTransaction/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_PACKAGE_TRANSACTION, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
